
































































































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import BlogCategoryForm from "@/components/blog/BlogCategoryForm.vue";
import { BlogCategory, Business, Role } from "@/types";

const { mapActions: categoryActions, mapGetters: categoryGetters } =
  createNamespacedHelpers("BLOG_CATEGORY_");

export default Vue.extend({
  name: "BlogCategoryList",
  components: {
    BlogCategoryForm,
  },
  data() {
    return {
      showCategoryForm: false,
      deleteDialog: false,
      deleteItem: null as BlogCategory | null,
      currentCategory: null as BlogCategory | null,
      search: "",
      showDebug: false,
      loading: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...categoryGetters(["categoryPage"]),
    role(): Role {
      return this.$store.getters.role;
    },
    categories(): BlogCategory[] {
      return this.categoryPage?.docs || [];
    },
    businessId(): string {
      if (!this.role || !this.role.business) return "";

      return typeof this.role.business === "string"
        ? this.role.business
        : (this.role.business as Business)._id;
    },
  },
  methods: {
    ...categoryActions(["fetchCategoryList", "deleteCategory"]),
    editCategory(category: BlogCategory) {
      this.currentCategory = category;
      this.showCategoryForm = true;
    },
    closeCategoryForm() {
      this.showCategoryForm = false;
      this.currentCategory = null;
    },
    confirmDelete(category: BlogCategory) {
      this.deleteItem = category;
      this.deleteDialog = true;
    },
    async deleteBlogCategory() {
      if (this.deleteItem && this.businessId) {
        try {
          this.loading = true;
          await this.deleteCategory({
            businessId: this.businessId,
            categoryId: this.deleteItem._id,
          });

          this.deleteDialog = false;
          this.deleteItem = null;
          this.refreshCategories();
        } catch (error) {
          console.error("Failed to delete category:", error);
        } finally {
          this.loading = false;
        }
      }
    },
    formatDate(dateString: string): string {
      if (!dateString) return "";

      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    refreshCategories() {
      if (this.businessId) {
        this.loading = true;
        this.fetchCategoryList({
          businessId: this.businessId,
          page: 1,
          limit: 20,
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    toggleDebug() {
      this.showDebug = !this.showDebug;
    },
  },
  mounted() {
    console.log("BlogCategoryList mounted");

    if (!this.$store.state.BLOG_CATEGORY_) {
      console.error("Store module not properly registered!");
      this.$store.dispatch("setToast", {
        title: "Error",
        type: "error",
        text: "Blog category module not properly loaded. Please contact support.",
        timeout: 5000,
      });
    } else {
      this.refreshCategories();
    }

    // Add keyboard shortcut for debug
    document.addEventListener("keydown", (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === "D") {
        this.toggleDebug();
      }
    });
  },
  beforeDestroy() {
    // Remove the event listener with proper reference to the handler
    document.removeEventListener("keydown", (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === "D") {
        this.toggleDebug();
      }
    });
  },
});
